import { Center, Spinner, VStack, Text, Box } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useUserStore } from '@store/app.store';
import { useLoginShared } from '@util/hooks';

export default function SessionCallbackPage() {
  const [searchParams] = useSearchParams();
  const [isAuthenticatingWithSession, setIsAuthenticatingWithSession] = useState(true);
  const authenticateWithSession = useUserStore((state) => state.authenticateWithSession);
  const user = useUserStore((state) => state.user);
  const navigate = useNavigate();
  const { openErrorToast } = useLoginShared();

  useEffect(() => {
    const handleAuth = async () => {
      try {
        // If user is already authenticated, don't re-authenticate
        if (user) return;

        const sessionId = searchParams.get('sessionId');
        const comingFrom = searchParams.get('comingFrom');

        if (!sessionId) {
          openErrorToast('No session ID provided. Please try again.');
          navigate('/login');
          return;
        }

        await authenticateWithSession(sessionId, { coming_from: comingFrom });
      } catch (error) {
        console.error('Session authentication failed:', error);
        openErrorToast('Session authentication failed. Please try again.');
        navigate('/login');
        setIsAuthenticatingWithSession(false);
      }
    };

    handleAuth();
  }, [searchParams, authenticateWithSession, navigate, openErrorToast, user]);

  // Separate useEffect to handle navigation after user data is loaded
  useEffect(() => {
    if (user && isAuthenticatingWithSession) {
      // User data is now available, safe to navigate
      const redirectTo = searchParams.get('redirectTo');
      const redirectUrl = redirectTo ? `/?redirectTo=${encodeURIComponent(redirectTo)}` : '/';
      navigate(redirectUrl);
      setIsAuthenticatingWithSession(false);
    }
  }, [user, isAuthenticatingWithSession, navigate, searchParams]);

  return (
    <Box data-cy='session-callback-page'>
      <Center pt={10}>
        {isAuthenticatingWithSession && (
          <VStack gap={6}>
            <Text fontSize='lg'>Logging you in...</Text>
            <Spinner size='xl' />
          </VStack>
        )}
      </Center>
    </Box>
  );
}
